import React, { useState } from 'react';
import { ArrowLeft, Bell, Copy } from 'lucide-react';

const ModifierKey = () => {
  const [cle, setCle] = useState('');
  const cleActuelle = 'a4925965c62c957edaa8070716113b93a91';

  const copyToClipboard = () => {
    navigator.clipboard.writeText(cleActuelle);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Nouvelle clé:', cle);
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-purple-50 to-white">
      {/* Header avec effet glassmorphism */}
      <header className="sticky top-0 bg-white/80 backdrop-blur-md px-4 py-3 flex items-center justify-between border-b border-purple-100/50">
        <div className="flex items-center space-x-4">
          <button className="p-2 hover:bg-purple-50 rounded-full transition-colors">
            <ArrowLeft className="w-6 h-6 text-blue-600" />
          </button>
          <h1 className="text-blue-600 text-lg font-semibold">Kappela Vendeur</h1>
        </div>
        <button className="p-2 hover:bg-purple-50 rounded-full transition-colors relative">
          <Bell className="w-6 h-6 text-gray-700" />
          <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
        </button>
      </header>

      {/* Main Content */}
      <main className="max-w-2xl mx-auto px-4 py-8">
        <h2 className="text-3xl font-bold text-gray-900 mb-8">
          Clé publique Fedapay
        </h2>

        {/* Clé actuelle avec effet glassmorphism */}
        <div className="bg-gray-900 backdrop-blur-lg text-white rounded-2xl p-8 mb-12 shadow-xl relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-gray-800 to-gray-900 opacity-90"></div>
          <div className="relative">
            <p className="text-gray-400 text-center mb-3">
              Votre clé publique Fedapay est :
            </p>
            <div className="flex items-center justify-center space-x-2">
              <p className="text-center font-mono text-sm select-all bg-gray-800/50 px-4 py-2 rounded-lg">
                {cleActuelle}
              </p>
              <button 
                onClick={copyToClipboard}
                className="p-2 hover:bg-gray-800 rounded-lg transition-colors"
              >
                <Copy className="w-5 h-5 text-gray-400" />
              </button>
            </div>
          </div>
        </div>

        {/* Formulaire de modification avec effet carte */}
        <div className="bg-white rounded-3xl p-8 shadow-lg border border-purple-100">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-2">
              <label className="block text-gray-700 font-medium">
                Votre clé
              </label>
              <input
                type="text"
                placeholder="Clé publique"
                className="w-full px-4 py-3.5 rounded-xl border border-gray-200 bg-gray-50/50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                value={cle}
                onChange={(e) => setCle(e.target.value)}
              />
            </div>

            <button
              type="submit"
              className="w-full bg-blue-600 text-white py-4 rounded-xl font-medium hover:bg-blue-700 transform hover:-translate-y-0.5 transition-all duration-200 shadow-md hover:shadow-lg"
            >
              Modifier la clé
            </button>
          </form>
        </div>
      </main>
    </div>
  );
};

export default ModifierKey;